import { Paper, Typography, Stack, Box } from '@mui/material';
import { History, CheckCircle, AccessTime, Sync, Logout } from '@mui/icons-material';
import { IAttendanceLog } from 'services/SchoolClass/types';

export function RecentLogs({ logs }: { logs: IAttendanceLog[] }) {
  const getLogConfig = (status: string) => {
    switch (status) {
      case 'Presente':
        return { 
          borderColor: 'success.main', 
          textColor: 'text.secondary', 
          icon: <CheckCircle color="success" sx={{ fontSize: 16 }} /> 
        };
      case 'Reentrada':
        return { 
          borderColor: 'info.main', 
          textColor: 'info.main', 
          icon: <Sync color="info" sx={{ fontSize: 16 }} /> 
        };
      case 'Atrasado':
        return { 
          borderColor: 'warning.main', 
          textColor: 'warning.main', 
          icon: <AccessTime color="warning" sx={{ fontSize: 16 }} /> 
        };
      case 'Saída':
        // 🔥 Caso adicionado: estilo cinza discreto com ícone de porta/saída
        return { 
          borderColor: 'text.disabled', 
          textColor: 'text.secondary', 
          icon: <Logout color="action" sx={{ fontSize: 16 }} /> 
        };
      default:
        // Fallback genérico para não mascarar status inesperados como "Atrasado"
        return { 
          borderColor: 'divider', 
          textColor: 'text.secondary', 
          icon: <History color="disabled" sx={{ fontSize: 16 }} /> 
        };
    }
  };

  return (
    <Paper 
      elevation={0} 
      sx={{ 
        p: 3, 
        borderRadius: 3, 
        border: '1px solid', 
        borderColor: 'divider', 
        bgcolor: 'background.paper', 
        height: '100%' 
      }}
    >
      <Typography 
        variant="subtitle2" 
        fontWeight="bold" 
        color="text.secondary" 
        textTransform="uppercase" 
        sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 3 }}
      >
        Últimos Registros <History fontSize="small" />
      </Typography>
      
      {logs.length === 0 ? (
        <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center', mt: 4 }}>
          Nenhum registro hoje.
        </Typography>
      ) : (
        <Stack spacing={3} sx={{ position: 'relative' }}>
          {/* Linha vertical que conecta os eventos da timeline */}
          <Box sx={{ position: 'absolute', top: 8, bottom: 8, left: 15, width: 2, bgcolor: 'divider', borderRadius: 1 }} />
          
          {logs.map((log) => {
            const config = getLogConfig(log.status);

            return (
              <Box key={log.id} sx={{ display: 'flex', gap: 2, position: 'relative', zIndex: 1 }}>
                <Box 
                  sx={{ 
                    width: 32, 
                    height: 32, 
                    flexShrink: 0,
                    borderRadius: '50%', 
                    bgcolor: 'background.paper', 
                    border: '2px solid', 
                    borderColor: config.borderColor,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                >
                  {config.icon}
                </Box>
                <Box>
                  <Typography variant="body2" fontWeight="bold" color="text.primary">
                    {log.name}
                  </Typography>
                  <Typography variant="caption" sx={{ color: config.textColor, fontWeight: 'medium' }}>
                    {log.time} - {log.status}
                  </Typography>
                </Box>
              </Box>
            );
          })}
        </Stack>
      )}
    </Paper>
  );
}